import { gpHome } from '../app';
import { AccountsService } from '../services/accounts-service';
import { IAuthService } from '../services/auth-service';
import { refusalMessage } from './confirm-refusal';

interface IConfirmEmailChangeScope extends ng.IScope {
    password: string;
    confirmationSuccessful: boolean;
    confirmationError: string | null;
    confirming: boolean;
    confirm(): void;
}

gpHome.controller(
    'confirmemailchangeController',
    [
        '$scope',
        'accountsService',
        'authService',
        '$routeParams',
        function (
            $scope: IConfirmEmailChangeScope,
            accountsService: AccountsService,
            authService: IAuthService,
            $routeParams: ng.route.IRouteParamsService) {

            let userId = $routeParams['userId'];
            let code = $routeParams['code'];

            $scope.password = '';

            $scope.confirm = () => {
                $scope.confirming = true;
                $scope.confirmationError = null;

                accountsService.confirmEmailChange(userId, code, $scope.password)
                    .then(() => {
                        $scope.confirmationSuccessful = true;
                        authService.logOut();
                    })
                    .catch(value => $scope.confirmationError = refusalMessage(value))
                    .finally(() => $scope.confirming = false);
            };
        }]);
